<template>
	<div class="inner-modal inner-modal--acc">
		<div class="acc">
			<div class="acc__inner">
				<div class="acc__form">
					<div class="acc__head">
						<h3 class="acc__heading">Forgot Password</h3>
						<p>Enter an email address and we'll email you a link to reset your password.</p>
						<template v-if="validationErrors.length">
							<template v-for="error in validationErrors">
								<p class="text-danger">{{error}}</p>
							</template>
						</template>
					</div>
					<template v-if="!emailSent">
						<div class="form-group">
							<label for="emailAddress">Email address<span class="text-danger">*</span></label>
							<input type="email" id="emailAddress" v-model="requestData.emailAddress" :class="[`form-control`, formValidationErrors?.emailAddress?.length ? 'is-invalid' : '']">
							<div class="invalid-feedback" v-for="error in formValidationErrors?.emailAddress">
								&bull; {{error}}
							</div>
						</div>
						<div class="text-center mt-3">
							<Cta type="primary" size="lg" label="Send" @onClick="send" :icon="[]" iconAlignment="left"> </Cta>
						</div>
					</template>
					<template v-else>
						<div class="text-center text-green">Password reset request sent. Please allow a few minutes for the mail servers to process your request and send you an email.</div>
					</template>
				</div>
				<div class="acc__more">
					<Cta type="outline" size="lg" label="Login" @onClick="login" :icon="[]" iconAlignment="left"> </Cta>
					<Cta type="outline" size="lg" label="Create New Account" @onClick="createAccount" :icon="[]" iconAlignment="left"> </Cta>
				</div>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
const componentName = 'AccountForgotPasswordModal';
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
const store = useStore();
import { useRouter } from 'vue-router';
import {UserForgotPassword} from "Api/apis";
const router = useRouter();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});
const requestData = ref<{ emailAddress: string }>({
	emailAddress: "",
});

const props = defineProps({
	pathPrefix: String
});

const createAccount = async() => {
	await router.push(`${props.pathPrefix}/register`);
};

const login = async() => {
	await router.push(`${props.pathPrefix}/login`);
};

const emailSent = ref<boolean>(false);

const send = async() => {
	await UserForgotPassword(requestData.value).then(async(response) => {
		if(response.isErrors) {
			emailSent.value = false;
			if(response.errorDetail.isError) {
				validationErrors.value = response.userFriendlyMessages;
			}
			if(response.formValidationMessages) {
				formValidationErrors.value = response.formValidationMessages;
			}
		} else {
			emailSent.value = true;
		}
	});
};


const closeModal = async() => {
	await store.dispatch('closeModal');
};
</script>
